"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProcessingOperation = exports.ItemForm = void 0;
var ItemForm;

(function (ItemForm) {
  ItemForm["Bar"] = "bar";
  ItemForm["Tube"] = "tube";
  ItemForm["Structural"] = "structural";
  ItemForm["Sheet"] = "sheet";
  ItemForm["Coil"] = "coil";
  ItemForm["CoiledTread"] = "coiled tread";
  ItemForm["Plate"] = "plate";
  ItemForm["Treadplate"] = "tread plate";
  ItemForm["Pipe"] = "pipe";
  ItemForm["PerforatedSheet"] = "perforated sheet";
})(ItemForm || (exports.ItemForm = ItemForm = {}));

var ProcessingOperation;

(function (ProcessingOperation) {
  ProcessingOperation["BandsawCut"] = "BSC";
  ProcessingOperation["CutToLength"] = "CTL";
  ProcessingOperation["Laser"] = "LZR";
  ProcessingOperation["OxyFuelBurning"] = "BRN";
  ProcessingOperation["Plasma"] = "PFC";
  ProcessingOperation["PrecisionBandsaw"] = "PBS";
  ProcessingOperation["Shear"] = "SHR";
  ProcessingOperation["ShearToLength"] = "STL";
  ProcessingOperation["ShearToWidth"] = "STW";
  ProcessingOperation["AluminumPlateSaw"] = "ABM";
  ProcessingOperation["AluminumPrecisionPlateSaw"] = "APS";
})(ProcessingOperation || (exports.ProcessingOperation = ProcessingOperation = {}));